/*
 *
 * PatientDetails constants
 *
 */

export const GET_PATIENT_DETAILS_REQUEST_SENT =
  'app/PatientDetails/GET_PATIENT_DETAILS_REQUEST_SENT';
export const GET_PATIENT_DETAILS_REQUEST_SUCCEED =
  'app/PatientDetails/GET_PATIENT_DETAILS_REQUEST_SUCCEED';
export const GET_PATIENT_DETAILS_REQUEST_FAILED =
  'app/PatientDetails/GET_PATIENT_DETAILS_REQUEST_FAILED';

export const REMOVE_PATIENT_REQUEST_SENT =
  'app/PatientDetails/REMOVE_PATIENT_REQUEST_SENT';
export const REMOVE_PATIENT_REQUEST_SUCCEED =
  'app/PatientDetails/REMOVE_PATIENT_REQUEST_SUCCEED';
export const REMOVE_PATIENT_REQUEST_FAILED =
  'app/PatientDetails/REMOVE_PATIENT_REQUEST_FAILED';

export const UPDATE_NEEDS_ATTENTION_REQUEST_SENT =
  'app/PatientDetails/UPDATE_NEEDS_ATTENTION_REQUEST_SENT';
export const UPDATE_NEEDS_ATTENTION_REQUEST_SUCCEED =
  'app/PatientDetails/UPDATE_NEEDS_ATTENTION_REQUEST_SUCCEED';
export const UPDATE_NEEDS_ATTENTION_REQUEST_FAILED =
  'app/PatientDetails/UPDATE_NEEDS_ATTENTION_REQUEST_FAILED';
export const RESET_NEEDS_ATTENTION = 'app/PatientDetails/RESET_NEEDS_ATTENTION';

export const GET_NOT_MOVING_FORWARD_REASONS_REQUEST_SENT =
  'app/PatientDetails/GET_NOT_MOVING_FORWARD_REASONS_REQUEST_SENT';
export const GET_NOT_MOVING_FORWARD_REASONS_REQUEST_SUCCEED =
  'app/PatientDetails/GET_NOT_MOVING_FORWARD_REASONS_REQUEST_SUCCEED';
export const GET_NOT_MOVING_FORWARD_REASONS_REQUEST_FAILED =
  'app/PatientDetails/GET_NOT_MOVING_FORWARD_REASONS_REQUEST_FAILED';

export const UPDATE_NOT_MOVING_FORWARD_REQUEST_SENT =
  'app/PatientDetails/UPDATE_NOT_MOVING_FORWARD_REQUEST_SENT';
export const UPDATE_NOT_MOVING_FORWARD_REQUEST_SUCCEED =
  'app/PatientDetails/UPDATE_NOT_MOVING_FORWARD_REQUEST_SUCCEED';
export const UPDATE_NOT_MOVING_FORWARD_REQUEST_FAILED =
  'app/PatientDetails/UPDATE_NOT_MOVING_FORWARD_REQUEST_FAILED';

export const RESEND_INVITE_REQUEST_SENT =
  'app/PatientDetails/RESEND_INVITE_REQUEST_SENT';
export const RESEND_INVITE_REQUEST_SUCCEED =
  'app/PatientDetails/RESEND_INVITE_REQUEST_SUCCEED';
export const RESEND_INVITE_REQUEST_FAILED =
  'app/PatientDetails/RESEND_INVITE_REQUEST_FAILED';

export const SET_PHASE_ID = 'app/PatientDetails/SET_PHASE_ID';

export const UPDATE_PATIENT_INFO_REQUEST_SENT =
  'app/PatientDetails/UPDATE_PATIENT_INFO_REQUEST_SENT';
export const UPDATE_PATIENT_INFO_REQUEST_SUCCEED =
  'app/PatientDetails/UPDATE_PATIENT_INFO_REQUEST_SUCCEED';
export const UPDATE_PATIENT_INFO_REQUEST_FAILED =
  'app/PatientDetails/UPDATE_PATIENT_INFO_REQUEST_FAILED';
export const RESET_PATIENT_DETAILS = 'app/PatientDetails/RESET_PATIENT_DETAILS';

export const TERMINATE_PROCEDURE_TRIAL_REQUEST_SENT =
  'app/PatientDetails/TERMINATE_PROCEDURE_TRIAL_REQUEST_SENT';
export const TERMINATE_PROCEDURE_TRIAL_REQUEST_SUCCEED =
  'app/PatientDetails/TERMINATE_PROCEDURE_TRIAL_REQUEST_SUCCEED';
export const TERMINATE_PROCEDURE_TRIAL_REQUEST_FAILED =
  'app/PatientDetails/TERMINATE_PROCEDURE_TRIAL_REQUEST_FAILED';

export const TRACK_PATIENT_AS_VIEWED_REQUEST_SENT =
  'app/PatientDetails/TRACK_PATIENT_AS_VIEWED_REQUEST_SENT';
export const TRACK_PATIENT_AS_VIEWED_REQUEST_SUCCEED =
  'app/PatientDetails/TRACK_PATIENT_AS_VIEWED_REQUEST_SUCCEED';
export const TRACK_PATIENT_AS_VIEWED_REQUEST_FAILED =
  'app/PatientDetails/TRACK_PATIENT_AS_VIEWED_REQUEST_FAILED';

export const UPDATE_SALESFORCE_ACCOUNT_FLAG_REQUEST_SENT =
  'app/PatientDetails/UPDATE_SALESFORCE_ACCOUNT_FLAG_REQUEST_SENT';
export const UPDATE_SALESFORCE_ACCOUNT_FLAG_REQUEST_SUCCEEDED =
  'app/PatientDetails/UPDATE_SALESFORCE_ACCOUNT_FLAG_REQUEST_SUCCEEDED';
export const UPDATE_SALESFORCE_ACCOUNT_FLAG_REQUEST_FAILED =
  'app/PatientDetails/UPDATE_SALESFORCE_ACCOUNT_FLAG_REQUEST_FAILED';

export const UPDATE_PHASE_REQUEST_SENT =
  'app/PatientDetails/UPDATE_PHASE_REQUEST_SENT';
export const UPDATE_PHASE_REQUEST_SUCCEEDED =
  'app/PatientDetails/UPDATE_PHASE_REQUEST_SUCCEEDED';
export const UPDATE_PHASE_REQUEST_FAILED =
  'app/PatientDetails/UPDATE_PHASE_REQUEST_FAILED';

export const EXIT_PATIENT_FROM_STUDY_REQUEST_SENT =
  'app/PatientDetails/EXIT_PATIENT_FROM_STUDY_REQUEST_SENT';
export const EXIT_PATIENT_FROM_STUDY_REQUEST_SUCCEEDED =
  'app/PatientDetails/EXIT_PATIENT_FROM_STUDY_REQUEST_SUCCEEDED';
export const EXIT_PATIENT_FROM_STUDY_REQUEST_FAILED =
  'app/PatientDetails/EXIT_PATIENT_FROM_STUDY_REQUEST_FAILED';
export const RESET_FLAG_FOR_PATIENT_INFO_UPDATED =
  'app/PatientDetails/RESET_FLAG_FOR_PATIENT_INFO_UPDATED';
export const REVOKE_ACCOUNT_DELETION_REQUEST_SUCCEED =
  'app/PatientDetails/REVOKE_ACCOUNT_DELETION_REQUEST_SUCCEED';
export const RESET_UNREAD_DIARY_COUNT =
  'app/PatientDetails/RESET_UNREAD_DIARY_COUNT';
